<script setup lang="ts">
import ThemeToggle from "@/components/Core/ThemeToggle.vue";
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
import { useToast } from "primevue/usetoast";
import { RouterView, useRoute } from "vue-router";
import { setErrorToastHandler } from "@/lib/helpers/errorToast";
import { computed, onMounted } from "vue";
import { navigationPending, navigationProgress } from "@/router/navigationProgress";

const route = useRoute();

// Project settings is a drawer over the project page, so it shares the page's
// key — otherwise opening it would remount the suites underneath.
const viewKey = computed(() => {
  if (route.name === "Case") return `case-${route.params.case_id}`;
  if (route.name === "Project Settings") return `/${route.params.project_id}`;
  return route.path;
});

onMounted(() => {
  const toast = useToast();
  setErrorToastHandler((opts) => toast.add(opts));
});
</script>

<template>
  <div class="mx-auto max-w-screen-2xl">
    <div
      v-if="navigationPending"
      role="progressbar"
      aria-label="Loading page"
      :aria-valuenow="Math.round(navigationProgress)"
      aria-valuemin="0"
      aria-valuemax="100"
      class="fixed inset-x-0 top-0 z-[10000] h-1 bg-brand-subtle"
    >
      <div
        class="h-full animate-pulse bg-brand transition-[width] duration-200 ease-out motion-reduce:animate-none motion-reduce:transition-none"
        :style="{ width: `${navigationProgress}%` }"
      />
    </div>
    <Toast />
    <!-- Moved off the bottom-right corner: its launcher sits above the theme
         toggle the design puts there and swallows the clicks meant for it. -->
    <VueQueryDevtools button-position="bottom-left" />
    <RouterView :key="viewKey" />
    <ThemeToggle />
  </div>
</template>
